<app-header 
  [icon]="'arrow_back_ios'"
  (iconClickedEvent)="back()">
</app-header>
<div class="container">
  <div class="calendar-container">
    
    <div class="google-calendar-container">
      @if (authService.user()?.profile === PROFILES.PSYCHOLOGIST.key) {    
        @if (loadingCalendarSync()) {
          <span class="loader"></span>
        }@else {
          @if(!calendarSynched()){
            <button class="add-btn" (click)="linkGoogleCalendar()">
              <mat-icon>link</mat-icon> {{ 'calendar.link' | translate }}
            </button>
          }@else {
            <button class="add-btn" (click)="unlinkGoogleCalendar()">
              <mat-icon>link_off</mat-icon> {{ 'calendar.unlink' | translate }}
            </button>
          }
          <span>{{ 'calendar.google_calendar' | translate }}</span>
          <div [class]="calendarSynched() ? 'status linked' : 'status non-linked'"></div>
        }        
      }
    </div>
      
    <div class="header">
      <button (click)="prev()"><mat-icon>keyboard_double_arrow_left</mat-icon></button>
      <h2>
        {{ translatedDate() }}
      </h2>
      <button (click)="next()"><mat-icon>keyboard_double_arrow_right</mat-icon></button>
    </div>    

    <div class="view-selector">
      @if (authService.user()?.profile === PROFILES.PSYCHOLOGIST.key) {
        <button class="add-btn" (click)="addAppointment()">
          <mat-icon>library_add</mat-icon>
          {{ 'calendar.add_event' | translate }}
        </button>
      }
      <button class="today-btn" (click)="goToday()">
        <mat-icon>today</mat-icon>
        {{ 'calendar.today' | translate }}
      </button>
    </div>
    @if (view() === 'month') {
      <div class="grid-month">
        @for (d of ['1','2','3','4','5','6','7']; track d) {
          <div class="weekday-label">
            {{ 'week-days.'+d | translate }}
          </div>
        }
        @for (day of monthDays(); track day.getTime()) {
          @if(day.getMonth() === currentDate().getMonth()){
            <div
              class="day-box"
              [class.weekend]="isWeekend(day)"
              [class.today]="isToday(day)"
              [class.holiday]="isHoliday(day)"
              (click)="openDay(appointments().get(getLocalDateKey(day)))"
            >
              <span>{{ day | date:'dd' }}</span>
              <div class="appointment-container">
                @if(appointments().get(getLocalDateKey(day))){
                  @for (item of appointments().get(getLocalDateKey(day)); track item.id) {
                    @if (item.status === STATUS.WAITING_CONFIRMATION.code) {
                      <div class="appointment waiting"></div>
                    }@else if (item.status === STATUS.CONFIRMED.code) {
                      <div class="appointment confirmed"></div>
                    }
                    @else if (item.status === STATUS.REJECTED.code) {
                      <div class="appointment rejected"></div>
                    }
                  }
                }
              </div>
            </div>
          }@else{
            <div class="day-box other-month"></div>
          }   
        }
      </div>
    }
    <div class="subtitles">
      <span class="waiting"></span><span>{{ 'status.waiting_confirmation' | translate }}</span>
      <span class="confirmed"></span><span>{{ 'status.confirmed' | translate }}</span>
      <span class="rejected"></span><span>{{ 'status.rejected' | translate }}</span>
    </div>
  </div>
</div>
